import { useMutation, queryClient } from '../../../ReactQuery';
import type { Banner, GetBannersResponse, UpdateBannerRequest } from '../../../../typings/api';
import { put } from '../../../redux/api';
import { bannersQueryKey } from './useBanners';

type UpdateBannerVariables = {
  id: number;
  banner: UpdateBannerRequest;
};

const updateBanner = ({ id, banner }: UpdateBannerVariables) =>
  put<UpdateBannerRequest, Banner>(`/api/banners/${id}`, banner);

/**
 * Hook for updating an existing banner.
 */
export default function useUpdateBanner() {
  return useMutation<UpdateBannerVariables, Response & { data?: Banner }>({
    mutationFn: updateBanner,
    onSuccess: (_response, { id, banner }: UpdateBannerVariables) => {
      //  Refetch the banners after updating an existing one
      queryClient.setQueryData<GetBannersResponse>(bannersQueryKey, (banners?: GetBannersResponse) => {
        return (banners ? banners.map((cachedBanner) => cachedBanner.id !== id ? cachedBanner : ({
          ...cachedBanner,
          ...banner,
        })) : []) as GetBannersResponse;
      });
    },
  });
}
